// shows only the start of the parameters "wind_speed" from i.e "wind_speed_16m:kn"
export const BARBS_SPEED_PARAMETERS = ["wind_speed", "wind_gusts", "ocean_current_speed", "stokes_drift_speed"];

export const BARBS_DIRECTION_PARAMETERS = ["mean_direction_total_swell", "mean_wave_direction"];

// All possible barbs icon parameters
export const BARBS_PARAMETERS = [...BARBS_SPEED_PARAMETERS, ...BARBS_DIRECTION_PARAMETERS];

export const SUPPORTED_BARBS_SPEED_UNITS = [":kn"];
export const SUPPORTED_BARBS_DIRECTION_UNITS = [":d"];

export const DEFAULT_WIND_SPEED_PARAMETER = "wind_speed_10m:kn";

export function isBarbsSpeedParameter(parameterUnit: string): boolean {
  return BARBS_SPEED_PARAMETERS.some((parameter) => parameterUnit.startsWith(parameter));
}

export function isBarbsDirectionParameter(parameterUnit: string): boolean {
  return BARBS_DIRECTION_PARAMETERS.some((parameter) => parameterUnit.startsWith(parameter));
}
